import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import {
  Box,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { WaitlistBooking } from "./WaitlistBooking";
import { WaitlistBookings_Agenda$key } from "./__generated__/WaitlistBookings_Agenda.graphql";

export const WaitlistBookings = ({
  onWaitlistBookingPress,
  agendaRef,
}: {
  onWaitlistBookingPress: (bookingId: string) => void;
  agendaRef: WaitlistBookings_Agenda$key;
}) => {
  const agenda = useFragment(WaitlistBookingsFragmentString, agendaRef);
  const NoRequestHeader = () => {
    return staffBookings?.length > 0 ? (
      <Text pt={6} pb={4} variant="mainBaseMedium">
        {t`No Requested Time`}
      </Text>
    ) : null;
  };

  const memberRequestedBookings =
    agenda?.queueSlot.bookings?.edges
      ?.filter((b) => b?.node && b?.node.request !== null)
      .sort((a, b) =>
        (a?.node?.request?.time ?? "").localeCompare(
          b?.node?.request?.time ?? ""
        )
      ) || [];

  const staffBookings =
    agenda?.queueSlot.bookings?.edges?.filter(
      (b) => b?.node && b?.node.request === null
    ) || [];

  return (
    <Box>
      <VStack>
        {memberRequestedBookings.map((item, index) => {
          return item?.node ? (
            <Box mt={index > 0 ? 2 : 0} key={item.node.id}>
              <WaitlistBooking
                onWaitlistBookingPress={onWaitlistBookingPress}
                key={index}
                queryRef={item.node}
              />
            </Box>
          ) : null;
        })}
      </VStack>
      <NoRequestHeader />
      <VStack>
        {staffBookings.map((item, index) => {
          return item?.node ? (
            <Box mt={index > 0 ? 2 : 0} key={item.node.id}>
              <WaitlistBooking
                onWaitlistBookingPress={onWaitlistBookingPress}
                key={index}
                queryRef={item.node}
              />
            </Box>
          ) : null;
        })}
      </VStack>
    </Box>
  );
};

export const WaitlistBookingsFragmentString = graphql`
  fragment WaitlistBookings_Agenda on Agenda {
    queueSlot {
      bookings(
        first: 1000
        orderBy: { field: REQUESTED_DATE_TIME, direction: ASC }
      ) @connection(key: "queueSlot_bookings") {
        edges {
          node {
            id
            ... on StandardBooking {
              request {
                time
              }
            }
            ... on LessonBooking {
              request {
                time
              }
            }
            ...WaitlistBooking_Booking
          }
        }
      }
    }
  }
`;
